import {PlusOutlined} from '@ant-design/icons';
import {Form, Modal, Upload} from 'antd';
import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import toast from 'react-hot-toast';

const POSITIONS = [1, 2, 3, 4, 5];

const ClickableTile = ({onSelect, preview, width = 100, height = 100, label}) => (
  <div className={'flex flex-col items-center'}>
    <Upload
      showUploadList={false}
      beforeUpload={file => {
        onSelect(file);
        return false;
      }}
      accept={'image/*'}
    >
      <div
        style={{width, height}}
        className={'border rounded flex items-center justify-center cursor-pointer overflow-hidden hover:border-blue-500 bg-gray-50'}
      >
        {preview ? (
          <img src={preview} alt={''} className={'w-full h-full object-cover'} />
        ) : (
          <PlusOutlined className={'text-xl text-gray-400'} />
        )}
      </div>
    </Upload>
    {label && <span className={'mt-1 text-sm text-gray-500'}>Pos {label}</span>}
  </div>
);

ClickableTile.propTypes = {
  onSelect: PropTypes.func.isRequired,
  preview: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const HomeImagesModal = ({open, onCancel, updateImageData, onSubmit}) => {
  const [topImages, setTopImages] = useState([]);
  const [middleImage, setMiddleImage] = useState(null);
  const [carouselFiles, setCarouselFiles] = useState({});

  useEffect(() => {
    if (!open) {return;}

    if (updateImageData) {
      setTopImages(updateImageData.images || []);
      setMiddleImage(updateImageData.middleImage || null);

      const prefill = {};
      updateImageData.carouselImages?.forEach(img => {
        prefill[img.position] = img.imageUrl;
      });
      setCarouselFiles(prefill);
    }
  }, [open, updateImageData]);

  const handleSubmit = async () => {
    if (!updateImageData?.id) {
      return toast.error('Missing Home ID');
    }

    const formData = new FormData();
    
    const carouselUpdates = [];

    for (let pos of POSITIONS) {
      const file = carouselFiles[pos];

      if (file instanceof File) {
        formData.append('carouselFiles', file);
        carouselUpdates.push({
          position: pos,
          width: pos === 1 ? 1200 : 350,
          height: pos === 1 ? 750 : 350,
        });
      }
    }
   
    const bannerUpdates = [];

    topImages.forEach((item, index) => {
      if (item instanceof File) {
        formData.append('images', item);
        bannerUpdates.push({index});
      }
    });
    
    if (middleImage instanceof File) {
      formData.append('middleImage', middleImage);
    }
    
    formData.append(
      'command',
      JSON.stringify({
        isActive: true,
        carouselUpdates,
        bannerUpdates,
      }),
    );

    onSubmit({id: updateImageData.id, formData});
  };

  return (
    <Modal open={open} title={'Update Home Images'} onCancel={onCancel} onOk={handleSubmit} width={900}>
      <Form layout={'vertical'}>
        {/* Top Images */}
        <div className={'md:flex hidden flex-col gap-2 flex-wrap'}>
          {topImages.map((img, i) => {
            const preview = typeof img === 'string' ? img : URL.createObjectURL(img);
            return (
              <ClickableTile
                width={540}
                height={140}
                key={i}
                preview={preview}
                onSelect={file =>
                  setTopImages(prev => prev.map((p, idx) => (idx === i ? file : p)))
                }
              />
            );
          })}
        </div>

        <div className={'md:hidden flex flex-col gap-2'}>
          {topImages.map((img, i) => {
            const preview = typeof img === 'string' ? img : URL.createObjectURL(img);
            return (
              <ClickableTile
                width={240}
                height={100}
                key={i}
                preview={preview}
                onSelect={file =>
                  setTopImages(prev => prev.map((p, idx) => (idx === i ? file : p)))
                }
              />
            );
          })}
        </div>

        {/* Middle Image */}
        {/* <h3 className={'mt-6'}>Middle Image</h3>
        <ClickableTile
          width={200}
          height={220}
          className={'flex justify-left'}
          preview={typeof middleImage === 'string' ? middleImage : middleImage ? URL.createObjectURL(middleImage) : null}
          onSelect={file => setMiddleImage(file)}
        /> */}

        {/* Carousel Images */}
        {/* <h3 className={'mt-6'}>Carousel Images</h3>
        <div className={'grid grid-cols-5 gap-3'}>
          {POSITIONS.map(pos => {
            const value = carouselFiles[pos];
            const preview = typeof value === 'string' ? value : value instanceof File ? URL.createObjectURL(value) : null;

            return (
              <ClickableTile
                key={pos}
                label={pos}
                preview={preview}
                onSelect={file => setCarouselFiles(prev => ({...prev, [pos]: file}))}
              />
            );
          })}
        </div> */}
      </Form>
    </Modal>
  );
};

HomeImagesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  updateImageData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};

export default HomeImagesModal;
